import { GetCurrentUserPopupAdMethod } from '@/apis/common';
import { GetGlobalConfig, GetMenuList } from '@/apis/system';
import { OptionType } from '@/apis/types';
import { GetLoginInfo, Permission } from '@/apis/user';
import { useRequest } from 'ahooks';
import { difference } from 'lodash-es';

interface OptionsMapType {
  [property: string]: string | number;
}

/**
 * TODO: 这里要优化下实现逻辑
 */
const GlobalModel = () => {
  const {
    data: user,
    loading: userLoading,
    run: asyncUser,
    refresh: refetchUser,
  } = useRequest(GetLoginInfo, { manual: true });
  const { data: config, loading: configLoading, runAsync: asyncConfig } = useRequest(GetGlobalConfig, { manual: true });
  const {
    data: menus,
    loading: menusLoading,
    run: asyncMenus,
    refresh: refreshMenus,
  } = useRequest(GetMenuList, { manual: true });

  /** 获取当前用户需要展示的广告 */
  const { runAsync: getCurrentUserPopupAd, data: adData } = useRequest(GetCurrentUserPopupAdMethod, {
    manual: true,
  });

  /** 因为没有区分作用域，用触发器来初始化全局配置 */
  const initial = () => {
    asyncUser();
    asyncConfig().then((response) => {
      document.title = response.platformName || '观麦采购系统';
      getCurrentUserPopupAd();
    });
    asyncMenus();
  };

  /** 获取options */
  const getOptions = (type: OptionType) => {
    return config?.dictInfoMap[type]?.map((option) => ({ value: option.itemValue, label: option.label || '-' })) || [];
  };

  // 用于显示
  const getOptionsTextMap = (type: OptionType) => {
    return (
      config?.dictInfoMap[type]?.reduce((pre: OptionsMapType, next) => {
        pre[next.itemValue!] = next.label!;
        return pre;
      }, {}) || {}
    );
  };

  // 用于判断
  const getOptionsValueMap = (type: OptionType) => {
    return (
      config?.dictInfoMap[type]?.reduce((pre: OptionsMapType, next) => {
        pre[next.itemValue!] = next.itemValue!;
        return pre;
      }, {}) || {}
    );
  };

  /** 是否具备某个/些权限 */
  const isPermission = (permission: Permission) => {
    const allPermission = user?.roleMenuIds;
    if (!allPermission) return false;
    if (Array.isArray(permission)) {
      return difference(permission, allPermission);
    }
    return allPermission.includes(permission);
  };

  return {
    /** 是否统一核销（为什么出现拼音？更直观） */
    isTongYiVfn: config?.cancelVfnMode === 1,
    user: user,
    config: config,
    menus: menus,
    /** 首个路由地址 */
    firstRoute: user?.indexUrl || '/',
    /** 全部加载完，才算loading结束 */
    loading: userLoading || configLoading || menusLoading,
    isSL: true,
    initial,
    isPermission,
    getOptions,
    getOptionsTextMap,
    getOptionsValueMap,
    refetchUser,
    refreshMenus,
    adData,
  };
};

export default GlobalModel;
